import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3e0c91b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-between items-center p-4 rounded-xl" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-bold" }, null, -1))
const _hoisted_3 = { class: "flex items-center space-x-4" }
const _hoisted_4 = {
  key: 0,
  class: "pl-2 text-lg font-bold"
}
const _hoisted_5 = { class: "dropdown dropdown-end z-10" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  tabindex: "0",
  class: "btn btn-ghost btn-circle avatar"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-10 rounded-full" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://i.pravatar.cc/300",
      alt: "User Avatar"
    })
  ])
], -1))
const _hoisted_7 = { class: "dropdown-content menu p-2 shadow bg-base-100 dark:bg-gray-700 rounded-md w-64 gap-2" }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col p-2"
}
const _hoisted_9 = { class: "font-bold" }
const _hoisted_10 = { class: "text-gray-600 text-sm" }
const _hoisted_11 = { class: "border-t" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.school)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.school.name), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("ul", _hoisted_7, [
          (_ctx.user)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.user.fullName), 1),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.user.role === 'Admin' ? 'Yönetici' : _ctx.user.role === 'Teacher' ? 'Parent' : 'Veli'), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: `/teacher/${_ctx.user.userId}`
            }, {
              default: _withCtx(() => [
                _createTextVNode("Yapay Zeka Asistanım")
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/settings" }, {
              default: _withCtx(() => [
                _createTextVNode("Ayarlar")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/help" }, {
              default: _withCtx(() => [
                _createTextVNode("Yardım")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_11, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
              class: "btn btn-sm text-white btn-error w-full mt-4"
            }, "Logout")
          ])
        ])
      ])
    ])
  ]))
}